export default function (store, ev) {
    if (!ev) {
        store.setState({ sort: null });
        return;
    }
    const state = store.getState();
    const columnId = ev.columnId;
    const by = ev.by || "label";
    const dir = ev.dir || "asc";
    const preserve = ev.preserve || false;
    let sort = state.sort || {};
    if (columnId) {
        if ("column" in sort === false) {
            sort = {
                columns: {},
            };
        }
        sort.columns[columnId] = { by, dir, preserve };
    }
    else {
        sort = {
            dir,
            by,
            preserve,
        };
    }
    const { cardsMap } = store.getInnerState({ ...state, sort });
    if (preserve) {
        store.setState({ sort, cardsMap });
    }
    else {
        store.setState({ cardsMap });
    }
}
//# sourceMappingURL=sort.js.map